var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tencent-code"},[_c('div',{staticStyle:{"width":"100%","height":"20px"},attrs:{"id":"TCaptcha"}})])
}]

export { render, staticRenderFns }